import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import Select from "react-select";
import {
  Box,
  Flex,
  Heading,
  HStack,
  SimpleGrid,
  Text,
  Container,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  InputRightElement,
  IconButton,

} from "@chakra-ui/react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  Badge,
  Center,
  Button,
  useColorModeValue
} from "@chakra-ui/react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import styles from "components/Styles/AsmStyles.js";
import API_CONFIG from "../../Configuration/apiConfig";
import apiClient from "../../Configuration/apiClient";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import {
  SearchIcon,
  CloseIcon,
  ViewIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import ViewDetails from "./viewDetails";
function AsmDp({ fromDate, toDate }) {
  const [regionList, setRegionList] = useState([]);
  const [subRegionList, setSubRegionList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedSubRegions, setSelectedSubRegions] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [error, setError] = useState(null);
  const [redScore, setRedScore] = useState(0);
  const [availabilityScore, setAvailabilityScore] = useState(0);
  const [activationScore, setActivationScore] = useState(0);
  const [coolerScore, setCoolerScore] = useState(0);
  const [bonusScore, setBonusScore] = useState(0);
  const [totalOutlets, setTotalOutlets] = useState(0);
  const [loadingScores, setLoadingScores] = useState(false);
  const [loadingSubRegion, setLoadingSubRegion] = useState(false);
  const [loadingCity, setLoadingCity] = useState(false);
  const [loadingChannel, setLoadingChannel] = useState(false);
  const [loadingType, setLoadingType] = useState(false);
  const [managerNames, setManagerNames] = useState([]);
  const [loadingASM, setLoadingASM] = useState(false);
  const [selectedASM, setSelectedASM] = useState(null);
  const [salesOfficers, setSalesOfficers] = useState([]);
  const [asmDetails, setAsmDetails] = useState(null);
  const [loadingSO, setLoadingSO] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loadingDMN, setLoadingDMN] = useState(false);
  const [selectedASMForChart, setSelectedASMForChart] = useState(null);
  const [channelScoreData, setChannelScoreData] = useState([]);
  const [loadingChannelScore, setLoadingChannelScore] = useState(false);
  const [filteredManagers, setFilteredManagers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridPageSize, setGridPageSize] = useState(5);
  const gridApiRef = useRef(null);
  const [selectedSo, setSelectedSo] = useState(null);
  const [showViewDetails, setShowViewDetails] = useState(false);

  const prevFiltersRef = useRef({})
  const isMountedRef = useRef(false)
  const isInitialMount = useRef(true);
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  // Custom styles for tables
  const customStyles = `
    .store-audit-grid.ag-theme-alpine {
      --ag-header-foreground-color: #ffffff !important;
      --ag-border-color: #e2e8f0;
      --ag-row-border-color: #e2e8f0;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-header-cell-label {
      color: #ffffff !important;
      font-weight: 600 !important;
      font-size: 14px !important;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-header-cell-text {
      color: #ffffff !important;
      font-weight: 600 !important;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-header-cell {
      background-color: #be1c0aff !important;
      color: #ffffff !important;
      font-weight: 600;
      font-size: 14px;
      padding: 16px 12px;
      border-right: 1px solid rgba(255, 255, 255, 0.2) !important;
      border-bottom: 2px solid #ffffff !important;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-cell {
      padding: 12px;
      border-right: 1px solid #e2e8f0 !important;
      border-bottom: 1px solid #e2e8f0 !important;
      line-height: normal;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-row {
      border-bottom: 1px solid #e2e8f0 !important;
    }
    
    .store-audit-grid .ag-cell-focus,
    .store-audit-grid .ag-row-focus{
      background-color: rgba(244, 0, 9, 0.08) !important;
      outline: none !important;
      border: none !important;
    }

    .store-audit-grid.ag-theme-alpine .ag-row:hover {
      background-color: #F7FAFC;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-header {
      border-bottom: 2px solid #ffffff !important;
    }
    
    .store-audit-grid.ag-theme-alpine .ag-root-wrapper {
      border: 1px solid #e2e8f0 !important;
      border-radius: 8px;
    }

    .store-audit-grid.ag-theme-alpine .ag-icon-filter,
    .store-audit-grid.ag-theme-alpine .ag-icon-menu,
    .store-audit-grid.ag-theme-alpine .ag-icon-asc,
    .store-audit-grid.ag-theme-alpine .ag-icon-desc {
      color: #ffffff !important;
    }

    .store-audit-grid.ag-theme-alpine .ag-header-cell-menu-button {
      color: #ffffff !important;
    }

    .store-audit-grid.ag-theme-alpine .ag-overlay-no-rows-wrapper {
      padding: 60px 20px !important;
    }

    .store-audit-grid.ag-theme-alpine .ag-paging-panel {
      display: none !important;
    }
    
    .store-audit-grid .ag-body-viewport {
      overflow-y: auto !important;
      overflow-x: hidden !important;
    }

    .store-audit-grid .ag-root-wrapper,
    .store-audit-grid .ag-body {
      overflow: hidden !important;
    }
  `;
  const getMonthRangeBody = () => {
    const [fromYear, fromMonthNum, fromDay] = fromDate.split('-').map(Number);
    const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);
    return {
      from: {
        date: fromDay,
        month: fromMonthNum,
        year: fromYear,
      },
      to: {
        date: toDay,
        month: toMonthNum,
        year: toYear
      }

    };
  };

  useEffect(() => {
    if (isOpen) {
      setGridCurrentPage(1);
    }
  }, [isOpen]);

  const handleGridPreviousPage = () => {
    if (gridCurrentPage > 1) {
      setGridCurrentPage(gridCurrentPage - 1);
      if (gridApiRef.current) {
        gridApiRef.current.paginationGoToPreviousPage();
      }
    }
  };

  const handleGridNextPage = () => {
    const totalPages = Math.ceil(salesOfficers.length / gridPageSize);
    if (gridCurrentPage < totalPages) {
      setGridCurrentPage(gridCurrentPage + 1);
      if (gridApiRef.current) {
        gridApiRef.current.paginationGoToNextPage();
      }
    }
  };

  const handleGridPageChange = (page) => {
    setGridCurrentPage(page);
    if (gridApiRef.current) {
      gridApiRef.current.paginationGoToPage(page - 1);
    }
  };

  useEffect(() => {
    setFilteredManagers(managerNames);
    setSearchQuery("");
  }, [managerNames]);


  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredManagers(managerNames);
      return;
    }
    const filtered = managerNames.filter((m) =>
      m.ManagerName.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredManagers(filtered);
  };

  const getFilterString = useCallback(() => {
    return JSON.stringify({
      fromDate,
      toDate,
      regions: selectedRegions.map(r => r.value).sort().join(','),
      subRegions: selectedSubRegions.map(sr => sr.value).sort().join(','),
      cities: selectedCities.map(c => c.value).sort().join(','),
      channels: selectedChannels.map(ch => ch.value).sort().join(','),
      types: selectedTypes.map(t => t.value).sort().join(',')
    })
  }, [fromDate, toDate, selectedRegions, selectedSubRegions, selectedCities, selectedChannels, selectedTypes])

  const regionOptions = useMemo(() => regionList.map(item => ({ value: item, label: item })), [regionList]);
  const subRegionOptions = useMemo(() => subRegionList.map(item => ({ value: item, label: item })), [subRegionList])
  const cityOptions = useMemo(() => cityList.map(item => ({ value: item, label: item })), [cityList])
  const channelOptions = useMemo(() => channelList.map(item => ({ value: item, label: item })), [channelList])
  const typeOptions = useMemo(() => typeList.map(item => ({ value: item, label: item })), [typeList])


  const handleSOAction = (data) => {
    setSelectedSo(data);
    setShowViewDetails(true);

  };

  const ActionCellRenderer = (props) => {
    return (
      <Button
        size="sm"
        colorScheme="red"
        variant="outline"
        leftIcon={<ViewIcon />}
        onClick={() => handleSOAction(props.data)}
        _hover={{ bg: "red.50" }}
      >
        View
      </Button>
    );
  };

  // Sales Officers column definition
  const salesOfficerColumns = useMemo(
    () => [
      { headerName: "Sales Officer Name", field: "soName", flex: 1.5, filter: 'agTextColumnFilter', cellStyle: { fontWeight: '400' } },

      { headerName: "Total Shops", field: "totalShops", flex: 1.2, filter: 'agNumberColumnFilter', cellStyle: { textAlign: 'center', fontWeight: '300' } },

      { headerName: " Red Score", field: "totalRedScore", flex: 1, filter: 'agNumberColumnFilter', cellStyle: { textAlign: 'center', fontWeight: '300' } },

      { headerName: "Availability Score", field: "availabilityScore", flex: 1, filter: 'agNumberColumnFilter', cellStyle: { textAlign: 'center', fontWeight: '300' } },
      { headerName: "Activation Score", field: "activationScore", flex: 1, filter: 'agNumberColumnFilter', cellStyle: { textAlign: 'center', fontWeight: '300' } },
      { headerName: "Cooler Score", field: "coolerScore", flex: 1, filter: 'agNumberColumnFilter', cellStyle: { textAlign: 'center', fontWeight: '300' } },
      { headerName: "Cooler Bonus", field: "coolerBonus", flex: 1, filter: 'agNumberColumnFilter', cellStyle: { textAlign: 'center', fontWeight: '300' } },
      {
        headerName: "Action",
        field: "actions",
        flex: 1,
        minWidth: 120,
        cellRenderer: ActionCellRenderer,
        filter: false,
        sortable: false,
        cellStyle: { textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }
      }
    ],
    []
  );

  const defaultColDef = useMemo(() => ({
    resizable: true,
    sortable: true,
    filter: true,
  }), []);

  // Fecth Bar chart  based on filter changes
  useEffect(() => {
    const currentFilterString = getFilterString()
    if (prevFiltersRef.current.scores === currentFilterString && !isInitialMount.current) {
      return
    }
    prevFiltersRef.current.scores = currentFilterString
    const fetchChannelScores = async () => {
      if (!fromDate || !toDate) {
        setChannelScoreData([]);
        return;
      }
      setLoadingChannelScore(true);
      const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
      try {
        let requestBody = {
          filters: {},
          timePeriod: getMonthRangeBody(),
          userId: userId,
        };

        if (selectedRegions.length > 0) {
          requestBody.filters.dropdown1 = selectedRegions.map((r) => r.value).join(", ");
        }

        if (selectedSubRegions.length > 0) {
          requestBody.filters.dropdown2 = selectedSubRegions.map((sr) => sr.value).join(", ");
        }

        if (selectedCities.length > 0) {
          requestBody.filters.dropdown3 = selectedCities.map((c) => c.value).join(", ");
        }

        if (selectedChannels.length > 0) {
          requestBody.filters.dropdown4 = selectedChannels.map((ch) => ch.value).join(", ");
        }

        if (selectedTypes.length > 0) {
          requestBody.filters.dropdown5 = selectedTypes.map((t) => t.value).join(", ");
        }

        if (selectedASMForChart) {
          requestBody.filters.asmName = selectedASMForChart;
        }
        const res = await apiClient.post(
          `${API_CONFIG.ENDPOINTS.ASM_REPORT.ChannelScores}`,
          requestBody
        );

        const chartData = [];

        const channelRows = res.data
          .filter((item) => item.isTotal === 0 && item.channelName)
          .map((item) => ({
            name: item.channelName,
            value: parseFloat(item.
              redscoreAverage
              || 0),
            totalStores: item.totalStores,
            availability: item.availabilityPercentage,
            activation: item.activationPercentage,
            isTotal: false,
          }));

        chartData.push(...channelRows);

        setChannelScoreData(chartData);
      } catch (err) {
        console.error("Failed to load channel scores:", err);
        setChannelScoreData([]);
      } finally {
        setLoadingChannelScore(false);
      }
    };

    fetchChannelScores();
  }, [
    selectedRegions,
    selectedSubRegions,
    selectedCities,
    selectedChannels,
    selectedTypes,
    fromDate,
    toDate,
    getFilterString
  ]);

  // Fetch scores based on filter changes
  useEffect(() => {
    const currentFilterString = getFilterString()
    if (prevFiltersRef.current.channelScores === currentFilterString && !isInitialMount.current) {
      return
    }
    prevFiltersRef.current.channelScores = currentFilterString

    const fetchScores = async () => {
      if (!fromDate || !toDate) {
        setRedScore(0);
        setAvailabilityScore(0);
        setActivationScore(0);
        setCoolerScore(0);
        setBonusScore(0);
        setTotalOutlets(0);
        return;
      }
      setLoadingScores(true);

      try {
        let filters = {};
        if (selectedRegions.length > 0) {
          filters = {
            dropdown1: selectedRegions.map((r) => r.value).join(", "),
            dropdown2: selectedSubRegions.map((sr) => sr.value).join(", "),
            dropdown3: selectedCities.map((c) => c.value).join(", "),
            dropdown4: selectedChannels.map((ch) => ch.value).join(", "),
            dropdown5: selectedTypes.map((t) => t.value).join(", "),
          };
        }

        const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(Number);
        const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);

        const requestBody = {
          filters: filters,
          timePeriod: {
            from: {
              date: fromDay,
              month: fromMonthNum,
              year: fromYear
            },
            to: {
              date: toDay,
              month: toMonthNum,
              year: toYear
            }
          }
        }

        const res = await apiClient.post(
          `${API_CONFIG.ENDPOINTS.ASM_REPORT.SCORES}`,
          requestBody
        );

        setRedScore(res.data.totalRedScore || 0);
        setAvailabilityScore(res.data.availabilityScore || 0);
        setActivationScore(res.data.activationScore || 0);
        setCoolerScore(res.data.coolerScore || 0);
        setBonusScore(res.data.coolerBonus || 0);
        setTotalOutlets(res.data.totalOutlets || 0);
      } catch (err) {
        console.error("Failed to load scores:", err);
        setError("Failed to load scores data.");
        setRedScore(0);
        setAvailabilityScore(0);
        setActivationScore(0);
        setCoolerScore(0);
        setBonusScore(0);
        setTotalOutlets(0);
      } finally {
        setLoadingScores(false);
      }
    };

    fetchScores();
  }, [
    selectedRegions,
    selectedSubRegions,
    selectedCities,
    selectedChannels,
    selectedTypes,
    fromDate,
    toDate,
    getFilterString,
  ]);

  // 1. Fetch Regions when MONTH changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (!fromDate || !toDate) return;
      setSubRegionList([]);
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      try {
        const requestBody = getMonthRangeBody();
        const userId = localStorage.getItem('userId') || sessionStorage.getItem('userId');

        const res = await apiClient.request({
          method: 'POST',
          url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.REGIONDP}`,
          data: requestBody,
          params: { userId },

        })

        setRegionList(Array.isArray(res.data) ? res.data : [res.data]);

        setSelectedRegions([]);
        setSubRegionList([]);
        setSelectedSubRegions([]);
        setCityList([]);
        setSelectedCities([]);
        setChannelList([]);
        setSelectedChannels([]);
        setTypeList([]);
        setSelectedTypes([]);
        setSelectedASM(null);
        setSalesOfficers([]);
        setAsmDetails(null);
        setIsOpen(false);
      } catch (err) {
        console.error("Failed to load regions:", err);
        setError("Failed to load region dropdown data.");
      }
    };
    fetchRegions();
  }, [fromDate, toDate]);

  // 2. Fetch SubRegions when REGIONS change
  useEffect(() => {
    if (selectedRegions.length === 0) {
      setSubRegionList([]);
      setSelectedSubRegions([]);
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      setSelectedASM(null);
      setSalesOfficers([]);
      setAsmDetails(null);
      setIsOpen(false);
      return;
    }
    const fetchSubRegion = async () => {
      if (!fromDate || !toDate) return;

      setLoadingSubRegion(true);
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);

      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedRegions.map((region) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.SUBREGIONDP}?regions=${encodeURIComponent(region.value)}`,
            data: requestBody,
          })
        );

        const results = await Promise.all(promises);
        const allSubRegions = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueSubRegions = [...new Set(allSubRegions)];
        setSubRegionList(uniqueSubRegions);
        setSelectedSubRegions([]);
      } catch (err) {
        console.error("Failed to load subRegions:", err);
        setError("Failed to load subregion dropdown data.");
        setSubRegionList([]);
      } finally {
        setLoadingSubRegion(false);
      }
    };
    fetchSubRegion();
  }, [selectedRegions, fromDate, toDate]);

  // 3. Fetch Cities when SUBREGIONS change
  useEffect(() => {
    if (selectedSubRegions.length === 0) {
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }

    const fetchCity = async () => {

      if (!fromDate || !toDate) {
        return;
      }


      setLoadingCity(true);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);

      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedSubRegions.map((subRegion) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.CITYDP}?subRegions=${encodeURIComponent(subRegion.value)}`,
            data: requestBody,
          })
        );

        const results = await Promise.all(promises);
        const allCities = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueCities = [...new Set(allCities)];
        setCityList(uniqueCities);
        setSelectedCities([]);
      } catch (err) {
        console.error("Failed to load cities:", err);
        setError("Failed to load city dropdown data.");
        setCityList([]);
      } finally {
        setLoadingCity(false);
      }
    };
    fetchCity();
  }, [selectedSubRegions, fromDate, toDate]);

  // 4. Fetch Channels when CITIES change
  useEffect(() => {
    if (selectedCities.length === 0) {
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }

    const fetchChannel = async () => {
      if (!fromDate || !toDate) {
        return;
      }

      setLoadingChannel(true);
      setTypeList([]);
      setSelectedTypes([]);

      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedCities.map((city) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.CHANNELDP}?cities=${encodeURIComponent(city.value)}`,
            data: requestBody,
          })
        );

        const results = await Promise.all(promises);
        const allChannels = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueChannels = [...new Set(allChannels)];
        setChannelList(uniqueChannels);
        setSelectedChannels([]);
      } catch (err) {
        console.error("Failed to load channels:", err);
        setError("Failed to load channel dropdown data.");
        setChannelList([]);
      } finally {
        setLoadingChannel(false);
      }
    };
    fetchChannel();
  }, [selectedCities, fromDate, toDate]);

  // 5. Fetch Types when CHANNELS change
  useEffect(() => {
    if (selectedChannels.length === 0) {
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }

    const fetchType = async () => {
      if (!fromDate || !toDate) {
        return;
      }

      setLoadingType(true);
      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedChannels.map((channel) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.TYPEDP}?channels=${encodeURIComponent(channel.value)}`,
            data: requestBody,
          })
        );

        const results = await Promise.all(promises);
        const allTypes = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueTypes = [...new Set(allTypes)];
        setTypeList(uniqueTypes);
        setSelectedTypes([]);
      } catch (err) {
        console.error("Failed to load types:", err);
        setError("Failed to load type dropdown data.");
        setTypeList([]);
      } finally {
        setLoadingType(false);
      }
    };
    fetchType();
  }, [selectedChannels, fromDate, toDate]);

  useEffect(() => {
    const currentFilterString = getFilterString()
    if (prevFiltersRef.current.asmNames === currentFilterString && !isInitialMount.current) {
      return
    }
    prevFiltersRef.current.asmNames = currentFilterString
    isInitialMount.current = false

    const fetchAsmNames = async () => {
      setManagerNames([]);
      setError(null);
      setSelectedASM(null);
      setSalesOfficers([]);
      setAsmDetails(null);
      setIsOpen(false);

      const requestBody = {
        filters: {},
        timePeriod: getMonthRangeBody(),
        userId: localStorage.getItem("userId") || sessionStorage.getItem("userId"),
      };
      if (selectedRegions.length > 0) {
        requestBody.filters.dropdown1 = selectedRegions.map(r => r.value).join(', ');
        if (selectedSubRegions.length > 0) {
          requestBody.filters.dropdown2 = selectedSubRegions.map(item => item.value).join(', ');
        }
        if (selectedCities.length > 0) {
          requestBody.filters.dropdown3 = selectedCities.map(c => c.value).join(', ');
        }
        if (selectedChannels.length > 0) {
          requestBody.filters.dropdown4 = selectedChannels.map(ch => ch.value).join(', ');
        }
        if (selectedTypes.length > 0) {
          requestBody.filters.dropdown5 = selectedTypes.map(t => t.value).join(', ');
        }
      }

      if (!fromDate || !toDate) {
        return;
      }
      setLoadingASM(true);

      try {
        const res = await apiClient.post(
          `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ASM_REPORT.ASM}?roleType=ASM`,
          requestBody
        );

        const data = (Array.isArray(res.data) ? res.data : [res.data]).map(
          (name) => ({
            ManagerName: typeof name === "string" ? name : name.ManagerName || name.name || name,
          })
        );


        setManagerNames(data);

        if (data.length === 0) {
          setError("No ASM found for selected filters.");
        }

      } catch (err) {
        console.error("Failed to fetch ASM names:", err);
        setError("Failed to fetch ASM names. Please try again.");
        setManagerNames([]);
      } finally {
        setLoadingASM(false);
      }
    };

    fetchAsmNames();

  }, [fromDate, toDate, selectedRegions, selectedSubRegions, selectedCities, selectedChannels, selectedTypes, getFilterString]);


  // Fetch sales officers details when ASM is selected
  useEffect(() => {
    const fetchSODetails = async () => {
      if (!selectedASM || !fromDate || !toDate) {
        setSalesOfficers([]);
        setAsmDetails(null);
        return;
      }

      setLoadingSO(true);

      try {
        const requestBody = {
          filters: {},
          timePeriod: getMonthRangeBody(),
        };

        if (selectedRegions.length > 0) {
          requestBody.filters.dropdown1 = selectedRegions
            .map((r) => r.value)
            .join(", ");
        }

        if (selectedSubRegions.length > 0) {
          requestBody.filters.dropdown2 = selectedSubRegions
            .map((sr) => sr.value)
            .join(", ");
        }

        if (selectedCities.length > 0) {
          requestBody.filters.dropdown3 = selectedCities
            .map((c) => c.value)
            .join(", ");
        }

        if (selectedChannels.length > 0) {
          requestBody.filters.dropdown4 = selectedChannels
            .map((ch) => ch.value)
            .join(", ");
        }

        if (selectedTypes.length > 0) {
          requestBody.filters.dropdown5 = selectedTypes
            .map((t) => t.value)
            .join(", ");
        }

        const url = `${API_CONFIG.ENDPOINTS.ASM_REPORT.MANAGERS}?asmName=${encodeURIComponent(
          selectedASM
        )}`;

        const res = await apiClient.post(url, requestBody);
        setAsmDetails(res.data);
        setSalesOfficers(res.data.salesOfficers || []);
      } catch (err) {
        console.error("Failed to fetch sales officers:", err);
        setSalesOfficers([]);
        setAsmDetails(null);
      } finally {
        setLoadingSO(false);
      }
    };

    fetchSODetails();
  }, [
    selectedASM,
    selectedRegions,
    selectedSubRegions,
    selectedCities,
    selectedChannels,
    selectedTypes,
  ]);

  // Calculate pagination values for AG Grid
  const totalGridPages = Math.ceil(salesOfficers.length / gridPageSize);
  const gridStartIndex = (gridCurrentPage - 1) * gridPageSize + 1;
  const gridEndIndex = Math.min(gridCurrentPage * gridPageSize, salesOfficers.length);

  return (
    <>
      <Container maxW="container.2xl" p="0" m="0">
        {/* Dropdown Row with Multi-Select */}
        <HStack
          spacing={{ base: 3, md: 5 }}
          mt="4"
          align="flex-start"
          flexDir={{ base: "column", lg: "row" }}
        >
          <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, lg: 0 }}
            br={{ base: "8px", lg: "8px" }}
          >
            <Select
              isMulti
              options={regionOptions}
              value={selectedRegions}
              onChange={setSelectedRegions}
              placeholder="Company Code"
              styles={styles.customSelectStyles}
              closeMenuOnSelect={false}
              isClearable
            />
          </Box>

          <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, lg: 0 }}
          >
            <Select
              isMulti
              options={subRegionOptions}
              value={selectedSubRegions}
              onChange={setSelectedSubRegions}
              placeholder="Sub Regions"
              styles={styles.customSelectStyles}
              closeMenuOnSelect={false}
              isLoading={loadingSubRegion}
              isDisabled={selectedRegions.length === 0}
            />
          </Box>

          <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, lg: 0 }}
          >
            <Select
              isMulti
              options={cityOptions}
              value={selectedCities}
              onChange={setSelectedCities}
              placeholder="Cities"
              styles={styles.customSelectStyles}
              closeMenuOnSelect={false}
              isLoading={loadingCity}
              isDisabled={selectedSubRegions.length === 0}
            />
          </Box>

          <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, lg: 0 }}
          >
            <Select
              isMulti
              options={channelOptions}
              value={selectedChannels}
              onChange={setSelectedChannels}
              placeholder="Channels"
              styles={styles.customSelectStyles}
              closeMenuOnSelect={false}
              isLoading={loadingChannel}
              isDisabled={selectedCities.length === 0}
            />
          </Box>

          <Box
            flex="1"
            width={{ base: "100%", lg: "auto" }}
            mb={{ base: 3, lg: 0 }}
          >
            <Select
              isMulti
              options={typeOptions}
              value={selectedTypes}
              onChange={setSelectedTypes}
              placeholder="Type"
              styles={styles.customSelectStyles}
              closeMenuOnSelect={false}
              isLoading={loadingType}
              isDisabled={selectedChannels.length === 0}
            />
          </Box>

          <Box
            bg="gray.800"
            color="white"
            px="4"
            py="3"
            borderRadius="lg"
            minW="150px"
            textAlign="center"
            fontWeight="bold"
            boxShadow="sm"
            width={{ base: "100%", lg: "auto" }}
          >
            <Text fontSize="sm" opacity={0.9}>
              Total Outlets
            </Text>
            <Text fontSize="2xl" fontWeight="bold">
              {loadingScores ? <Spinner size="sm" /> : totalOutlets}
            </Text>
          </Box>
        </HStack>

        <Flex
          mt={6}
          gap={6}
          align="stretch"
          flexDir={{ base: "column", lg: "row" }}
        >
          <Box width={{ base: "100%", lg: "30%" }}>
            <SimpleGrid
              columns={{ base: 2, md: 1 }}
              spacing={4}
              mt={0}
              align="center"
            >
              <Box
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                transition="all 0.2s"
              >
                <Text fontSize="md" fontWeight="medium" color="gray.800">
                  Average Total Red Score
                </Text>
                <Text fontWeight="bold" fontSize="xl" color="red.500">
                  {loadingScores ? (<Spinner size="sm" />) : (redScore > 0 ? `${redScore}` : "0")}
                </Text>
              </Box>
              <Box
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                transition="all 0.2s"
              >
                <Text fontSize="md" fontWeight="medium" color="gray.800">
                 Average Availability
                </Text>
                <Text fontWeight="bold" fontSize="xl" color="green.500">
                  {loadingScores ? (<Spinner size="sm" />) : (availabilityScore > 0 ? `${availabilityScore}` : "0")}
                </Text>
              </Box>

              <Box
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                transition="all 0.2s"
              >
                <Text fontSize="md" fontWeight="medium" color="gray.800">
                  Average Activation
                </Text>
                <Text fontWeight="bold" fontSize="xl" color="yellow.500">
                  {loadingScores ? (<Spinner size="sm" />) : (activationScore > 0 ? `${activationScore}` : "0")}
                </Text>
              </Box>

              <Box
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                transition="all 0.2s"
              >
                <Text fontSize="md" fontWeight="medium" color="gray.800">
                  Average Cooler
                </Text>
                <Text fontWeight="bold" fontSize="xl" color="red.500">
                  {loadingScores ? <Spinner size="sm" /> : `${coolerScore}`}
                </Text>
              </Box>

              <Box
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{ boxShadow: "md", transform: "translateY(-2px)" }}
                transition="all 0.2s"
              >
                <Text fontSize="md" fontWeight="medium" color="gray.800">
                  Average Cooler Bonus
                </Text>
                <Text fontWeight="bold" fontSize="xl" color="blue.500">
                  {loadingScores ? (<Spinner size="sm" />) : (bonusScore > 0 ? `${bonusScore}` : "0")}
                </Text>
              </Box>
            </SimpleGrid>
          </Box>

          <Box
            bg="white"
            p={{ base: 4, md: 6, lg: 8 }}
            borderRadius="xl"
            boxShadow="sm"
            width="100%"
            height="500px"
            border="1px solid"
            borderColor="gray.200"
          >
            <Text
              fontSize={{ base: "xl", md: "2xl" }}
              textAlign="center"
              fontWeight="bold"
              color="gray.800"
              mb={4}
            >
              Score by Channel
            </Text>
            <Box height="100%" pt="20px">
              {loadingChannelScore ? (
                <Flex justify="center" align="center" height="200px">
                  <Spinner size="xl" color="red.600" />
                </Flex>
              ) : channelScoreData.length === 0 ? (
                <Text textAlign="center" color="gray.600">
                  No Chart Data Available
                </Text>
              ) : (
                <Box
                  w="100%"
                  h="100%"
                  position="relative"
                  className="bar-chart-container"
                >
                  <ResponsiveContainer width="100%" height={430}>
                    <BarChart
                      height={450}
                      data={channelScoreData}
                      margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                    >
                      <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="#E2E8F0"
                        vertical={false}
                      />
                      <XAxis
                        dataKey="name"
                        axisLine={{ stroke: "#CBD5E0" }}
                        tickLine={false}
                        tick={{
                          fontSize: 12,
                          fill: "#4A5568",
                          fontWeight: 500,
                        }}
                        height={80}
                        interval={0}
                        tickFormatter={(value) => {
                          if (value.length > 6) {
                            return value.substring(0, 6) + "...";
                          }
                          return value;

                        }}
                        label={{
                          value: "Channels",
                          offset: -10,
                          dx: -10,
                          style: { fontSize: 18, fill: '#4A5568', fontWeight: 600 }
                        }}

                      />
                      <YAxis
                        axisLine={{ stroke: "#CBD5E0" }}
                        tickLine={false}
                        tick={{
                          fontSize: 12,
                          fill: "#07090bff",
                          fontWeight: 500,
                        }}
                        width={60}
                        tickFormatter={(value) => `${value}`}
                        label={{
                          position: 'insideLeft',
                          content: ({ viewBox }) => {
                            const { x, y, height } = viewBox;
                            return (
                              <text
                                x={x + 15}
                                y={y + height / 2 + 20}
                                textAnchor="middle"
                                transform={`rotate(-90, ${x - 10}, ${y + height / 2})`}
                                style={{ fontSize: 18, fill: '#4A5568', fontWeight: 600 }}
                              >
                               Redscore
                              </text>
                            );
                          }

                        }}
                      />
                      <Tooltip
                        formatter={(value, name) => [`${value}`, "Score"]}
                        labelFormatter={(label) => {
                          const fullData = channelScoreData.find(
                            (item) =>
                              item.name.substring(0, 6) === label.substring(0, 6)
                          );
                          return `Channel: ${fullData?.name || label}`;
                        }}
                        contentStyle={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #E2E8F0",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                          fontSize: "14px",
                          fontWeight: "500",
                          maxWidth: "300px",
                          wordWrap: "break-word",
                        }}
                        itemStyle={{
                          color: "#F40009",
                          fontWeight: "600",
                        }}
                        labelStyle={{
                          color: "#2D3748",
                          fontWeight: "600",
                          marginBottom: "8px",

                        }}
                      />

                      <Bar
                        dataKey="value"
                        fill="#c84145ff"
                        radius={[4, 4, 0, 0]}
                        stroke="#ffffff"
                        strokeWidth={2}
                        barSize={Math.max(
                          20,
                          (((document.querySelector(".bar-chart-container")
                            ?.offsetWidth || 800) -
                            100) /
                            channelScoreData.length) *
                          0.7
                        )}
                        name="Score"
                        label={({ x, y, width, height, value }) => {
                          if (height === 0) return null;
                          return (
                            <text
                              x={x + width / 2}
                              y={y - 10}
                              fill="#F40009"
                              textAnchor="middle"
                              fontSize={12}
                              fontWeight="600"
                            >
                              {value}
                            </text>
                          );
                        }}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Box>
              )}
            </Box>
          </Box>
        </Flex>

        {/* AG Grid with ASM Names */}
        <Box
          mt="10"
          bg="white"
          borderRadius="xl"
          overflow="hidden"
          boxShadow="sm"
        >
          <Flex
            justify="space-between"
            align="center"
            p={4}
            borderBottom="1px solid"
            borderColor="gray.200"
          >
            <InputGroup maxW="400px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Search Area Sales Manager..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                bg="white"
                borderColor="gray.300"
                focusBorderColor="red.500"
                _placeholder={{ color: "gray.400" }}
              />
              {searchQuery && (
                <InputRightElement>
                  <IconButton
                    aria-label="Clear search"
                    size="sm"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setSearchQuery("");
                      setFilteredManagers(managerNames);
                    }}
                    variant="ghost"
                  />
                </InputRightElement>
              )}
            </InputGroup>

            <Text fontSize="sm" color="gray.600" mr={4}>
              {filteredManagers.length} managers found
            </Text>
          </Flex>

          <Box p={4}>
            {!fromDate || !toDate ? (
              <Center h="400px" bg="gray.50" borderRadius="lg">
                <Text color="gray.600">Select a month to load managers.</Text>
              </Center>
            ) : filteredManagers.length === 0 ? (
              <Center h="400px" bg="gray.50" borderRadius="lg">
                <Text color="gray.600">
                  {loadingDMN
                    ? "Loading distributors..."
                    : searchQuery
                      ? `No managers found matching "${searchQuery}"`
                      : "No managers found."}
                </Text>
              </Center>
            ) : (
              <Box>
                {/* Table Container */}
                <Box
                  maxH="400px"
                  overflowY="auto"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="lg"
                >
                  <Table variant="simple" size="md">
                    <Thead bg="gray.50" position="sticky" top={0} zIndex={1}>
                      <Tr>
                        <Th
                          fontWeight="bold"
                          color="gray.700"
                          borderColor="gray.200"
                          width="60%"
                        >
                          Manager Name
                        </Th>
                        <Th
                          fontWeight="bold"
                          color="gray.700"
                          borderColor="gray.200"
                          width="20%"
                        ></Th>
                        <Th
                          fontWeight="bold"
                          color="gray.700"
                          borderColor="gray.200"
                          width="20%"
                        >
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {filteredManagers
                        .slice(
                          (currentPage - 1) * pageSize,
                          currentPage * pageSize
                        )
                        .map((manager, index) => (
                          <Tr
                            key={manager.ManagerName}
                            _hover={{ bg: "red.50" }}
                            transition="background 0.2s"
                          >
                            <Td borderColor="gray.200">
                              <Flex align="center">
                                <Avatar
                                  size="sm"
                                  name={manager.ManagerName}
                                  mr={3}
                                  bg="red.500"
                                  color="white"
                                />
                                <Box>
                                  <Text fontWeight="medium" color="gray.800">
                                    {manager.ManagerName}
                                  </Text>
                                  <Text fontSize="xs" color="gray.500">
                                    Area Sales Manager
                                  </Text>
                                </Box>
                              </Flex>
                            </Td>
                            <Td borderColor="gray.200">
                              <Badge
                                colorScheme="red"
                                variant="subtle"
                                px={3}
                                py={1}
                                borderRadius="full"
                                fontSize="sm"
                              ></Badge>
                            </Td>
                            <Td borderColor="gray.200">
                              <Button
                                size="sm"
                                colorScheme="red"
                                variant="outline"
                                leftIcon={<ViewIcon />}
                                onClick={() => {
                                  setSelectedASM(manager.ManagerName);
                                  setIsOpen(true);
                                }}
                                _hover={{ bg: "red.50" }}
                              >
                                View Details
                              </Button>
                            </Td>
                          </Tr>
                        ))}
                    </Tbody>
                  </Table>
                </Box>

                {/* Pagination */}
                <Flex justify="space-between" align="center" mt={4} px={2}>
                  <Text fontSize="sm" color="gray.600">
                    Showing{" "}
                    {Math.min(
                      (currentPage - 1) * pageSize + 1,
                      filteredManagers.length
                    )}{" "}
                    to{" "}
                    {Math.min(currentPage * pageSize, filteredManagers.length)}{" "}
                    of {filteredManagers.length} managers
                  </Text>

                  <HStack spacing={2}>
                    <Button
                      size="sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      isDisabled={currentPage === 1}
                      variant="outline"
                      leftIcon={<ChevronLeftIcon />}
                    >
                      Previous
                    </Button>

                    {Array.from(
                      { length: Math.ceil(filteredManagers.length / pageSize) },
                      (_, i) => i + 1
                    )
                      .filter(
                        (page) =>
                          page === 1 ||
                          page === currentPage ||
                          page === currentPage - 1 ||
                          page === currentPage + 1 ||
                          page === Math.ceil(filteredManagers.length / pageSize)
                      )
                      .map((page, index, array) => (
                        <React.Fragment key={page}>
                          {index > 0 && array[index - 1] !== page - 1 && (
                            <Text color="gray.400">...</Text>
                          )}
                          <Button
                            size="sm"
                            onClick={() => setCurrentPage(page)}
                            colorScheme={currentPage === page ? "red" : "gray"}
                            variant={currentPage === page ? "solid" : "outline"}
                            minW="40px"
                          >
                            {page}
                          </Button>
                        </React.Fragment>
                      ))}

                    <Button
                      size="sm"
                      onClick={() =>
                        setCurrentPage((prev) =>
                          Math.min(
                            prev + 1,
                            Math.ceil(filteredManagers.length / pageSize)
                          )
                        )
                      }
                      isDisabled={
                        currentPage ===
                        Math.ceil(filteredManagers.length / pageSize) ||
                        filteredManagers.length === 0
                      }
                      variant="outline"
                      rightIcon={<ChevronRightIcon />}
                    >
                      Next
                    </Button>
                  </HStack>
                </Flex>
              </Box>
            )}
          </Box>
        </Box>
        <Modal
          isOpen={isOpen}
          isCentered
          motionPreset="slideInBottom"
          scrollBehavior="inside"
          blockScrollOnMount={false}
          onClose={() => {
            setIsOpen(false);
            setSelectedASM(null);
            setSalesOfficers([]);
            setAsmDetails(null);
            setGridCurrentPage(1);
            setShowViewDetails(false);
            setSelectedSo(null);
          }}
          size="2xl"
        >
          <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
          <ModalContent
            maxH="90vh"
            maxW="75vw"
            bg="white"
            borderRadius="2xl"
            boxShadow="2xl"
            overflow="hidden"
          >
            <ModalHeader
              bgGradient="linear(to-r, red.600, red.500)"
              color="white"
              py={6}
              px={8}
              borderBottom="1px solid"
              borderColor="red.700"
            >
              {showViewDetails ? (
                <Flex align="center" gap={3}>
                  <Button
                    size="sm"
                    variant="ghost"
                    color="white"
                    leftIcon={<ChevronLeftIcon />}
                    onClick={() => {
                      setShowViewDetails(false);
                      setSelectedSo(null);
                    }}
                    _hover={{ bg: "red.700" }}
                  >
                    Back
                  </Button>
                  <Text>Store Details for {selectedSo?.soName}</Text>
                </Flex>
              ) : (
                `Sales Officers for ${selectedASM}`
              )}
            </ModalHeader>
            <ModalCloseButton color="white" size="lg" variant="ghost" _hover={{ bg: "red.700" }} />
            <ModalBody px={8} py={8} >
              {showViewDetails ? (
                <ViewDetails salesOfficer={selectedSo} fromDate={fromDate} toDate={toDate} />

              ) : (
                <>
                  {asmDetails && (
                    <Box
                      mb={6}
                      p={4}
                      bg="white"
                      borderRadius="lg"
                      boxShadow="sm"
                      border="1px solid"
                      borderColor="gray.200"
                    >
                      <Heading size="md" mb={3} color="gray.800" fontWeight="bold">
                        ASM Summary
                      </Heading>
                      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Total Shops
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="red.600">
                            {asmDetails.totalShops || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Average Total Red Score
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="red.600">
                            {asmDetails.totalRedScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Availability Score
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="green.600">
                            {asmDetails.availabilityScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Activation Score
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="yellow.600">
                            {asmDetails.activationScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Cooler
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="pink.600">
                            {asmDetails.coolerScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Cooler Bonus
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="pink.600">
                            {asmDetails.coolerBonus || 0}
                          </Text>
                        </Box>
                      </SimpleGrid>
                    </Box>
                  )}
                  <Box
                    height={{ base: "60vh", md: "400px" }}
                    bg={bgColor}
                    borderRadius="lg"
                    boxShadow="md"
                    overflow="hidden"
                    border="1px solid"
                    borderColor={borderColor}
                  >
                    <style>{customStyles}</style>
                    <Box className="store-audit-grid ag-theme-alpine" style={{ height: "100%", width: '100%' }}>
                      <AgGridReact
                        rowData={salesOfficers}
                        columnDefs={salesOfficerColumns}
                        suppressHorizontalScroll={true}
                        onGridReady={(params) => {
                          gridApiRef.current = params.api;
                          params.api.sizeColumnsToFit();
                          const resize = () => params.api.sizeColumnsToFit();
                          window.addEventListener("resize", resize);
                          return () => window.removeEventListener("resize", resize);
                        }}
                        defaultColDef={defaultColDef}
                        rowHeight={60}
                        headerHeight={60}
                        pagination={true}
                        paginationPageSize={gridPageSize}
                        suppressPaginationPanel={true}
                        suppressMovableColumns={true}
                        domLayout="normal"
                        animateRows={true}
                        loadingOverlayTemplate={`
                      <div style="padding: 20px; font-size: 16px; color: #555;">
                        Loading sales officers data...
                      </div>
                    `}
                        overlayNoRowsTemplate={`
                      <div style="padding: 20px; font-size: 16px; color: #999;">
                        No sales officers found for this ASM.
                      </div>
                    `}
                        suppressNoRowsOverlay={loadingSO}
                      />
                    </Box>
                  </Box>

                  {/* Custom Pagination for AG Grid */}
                  {salesOfficers.length > 0 && (
                    <Flex justify="space-between" align="center" mt={4} px={2}>
                      <Text fontSize="sm" color="gray.600">
                        Showing {gridStartIndex} to {gridEndIndex} of {salesOfficers.length} sales officers
                      </Text>

                      <HStack spacing={2}>
                        <Button
                          size="sm"
                          onClick={handleGridPreviousPage}
                          isDisabled={gridCurrentPage === 1}
                          variant="outline"
                          leftIcon={<ChevronLeftIcon />}
                          colorScheme="red"
                        >
                          Previous
                        </Button>

                        {Array.from(
                          { length: totalGridPages },
                          (_, i) => i + 1
                        )
                          .filter(
                            (page) =>
                              page === 1 ||
                              page === gridCurrentPage ||
                              page === gridCurrentPage - 1 ||
                              page === gridCurrentPage + 1 ||
                              page === totalGridPages
                          )
                          .map((page, index, array) => (
                            <React.Fragment key={page}>
                              {index > 0 && array[index - 1] !== page - 1 && (
                                <Text color="gray.400">...</Text>
                              )}
                              <Button
                                size="sm"
                                onClick={() => handleGridPageChange(page)}
                                colorScheme={gridCurrentPage === page ? "red" : "gray"}
                                variant={gridCurrentPage === page ? "solid" : "outline"}
                                minW="40px"
                              >
                                {page}
                              </Button>
                            </React.Fragment>
                          ))}

                        <Button
                          size="sm"
                          onClick={handleGridNextPage}
                          isDisabled={gridCurrentPage === totalGridPages || salesOfficers.length === 0}
                          variant="outline"
                          rightIcon={<ChevronRightIcon />}
                          colorScheme="red"
                        >
                          Next
                        </Button>
                      </HStack>
                    </Flex>
                  )}
                </>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Container>
    </>
  );
}

export default AsmDp;